import React, { useState, useEffect } from "react";

import { getClientDetails } from "../../utils/Api";
import { handleLoaderEvent } from "../../utils/LoaderEmitter";

import moment from "moment";

import { Image } from "@fluentui/react-northstar";
import { iconAssets } from "../../assets/theme/theme";

import "react-datepicker/dist/react-datepicker.css";
import "../../styles/ViewClient.css";

const ClientHome = ({ userId }) => {

  const [clientDetails, setClientDetails] = useState({});
  const [licenseDetails, setLicenseDetails] = useState({});
  const [clientAdmin, setClientAdmin] = useState({});

  const refreshClientDetails = async () => {
    handleLoaderEvent.emit("loader", true);
    setLicenseDetails({});
    setClientAdmin({});
    setClientDetails({});
    let clientInfo = await getClientDetails(userId);
    if (!clientInfo) {
      return;
    }
    setLicenseDetails(clientInfo["licenseDetails"]);
    setClientAdmin(clientInfo["customerAdmin"]);
    setClientDetails(clientInfo["customer"]);
    handleLoaderEvent.emit("loader", false);
  };

  useEffect(() => {
    refreshClientDetails();
  }, []);

  return (
    <div>
      <div className="row p-0 m-0 w-100 mt-5">
        <div className="col-auto px-2 d-flex align-items-center">
          <div className="row p-0 m-0">
            <div className="col-auto pe-1">
              <Image src={iconAssets.phone} alt="" className="phone-icon" />
            </div>
            <div className="col-auto ps-1 d-flex align-items-center">{clientDetails["phone"]}</div>
          </div>
        </div>
        <div className="col-auto px-2 d-flex align-items-center">
          <div className="row p-0 m-0">
            <div className="col-auto pe-1">
              <Image src={iconAssets.email} alt="" className="email-icon" />
            </div>
            <div className="col-auto ps-1 d-flex align-items-center">{clientDetails["email"]}</div>
          </div>
        </div>
        <div className="col-auto px-2 d-flex align-items-center">
          <div className="row p-0 m-0">
            <div className="col-auto pe-1">
              <Image src={iconAssets.web} alt="" className="web-icon" />
            </div>
            <div className="col-auto ps-1 d-flex align-items-center">{clientDetails["domain_name"]}</div>
          </div>
        </div>
      </div>
      <div className="content-title mt-5 p-2 px-4">Admin</div>
      <div className="row p-2 px-4 m-0 w-100 mt-2 content-description">
        <div className="col-3 p-0">
          {clientAdmin["first_name"]} {clientAdmin["last_name"]}
        </div>
        <div className="col p-0">
          <div className="row p-0 m-0">
            <div className="col-auto p-0">
              <Image src={iconAssets.email} alt="" className="email-icon" />
            </div>
            <div className="col-auto ps-2">{clientAdmin["email"]}</div>
          </div>
        </div>
      </div>
      <div className="content-title row p-0 m-0 mt-5 p-2 px-4">
        <div className="col-auto p-0 content-title-text">License</div>
      </div>
      <div className="row p-0 m-0 w-100 mt-2">
        <div className="col">
          <div className="license-title">Total number of license</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{licenseDetails["totalNumberOfLicenses"]}</div>
        </div>
        <div className="col">
          <div className="license-title">Number of used License</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{licenseDetails["numberOfLicenseUsed"]}</div>
        </div>
        <div className="col">
          <div className="license-title">License start date</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{moment(licenseDetails["startDate"]).format("DD MMM, YYYY")}</div>
        </div>
        <div className="col">
          <div className="license-title">Expiry date</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{moment(licenseDetails["expiryDate"]).format("DD MMM, YYYY")}</div>
        </div>
        <div className="col">
          <div className="license-title">Duration(Months)</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{licenseDetails["duration"]}</div>
        </div>
      </div>
    </div>
  );
};

export default ClientHome;
